import React, { useState } from 'react'
import { Button, Checkbox, SearchInput } from '@offerzen/pinata'
import styles from './style'
import PropTypes from 'prop-types'

const RolesFilter = ({ roles, onApply, filterValues, closeFilter }) => {
  const [selectedRoles, setSelectedRoles] = useState(filterValues || [])
  const [keyword, setKeyword] = useState(null)

  return (
    <section role="roles-filter" className={styles.wrapper}>
      <SearchInput
        className={styles.search}
        placeholder="Select role"
        value={keyword}
        onChange={e => {
          if (e.target.value.length < 1) {
            setKeyword(null)
          } else {
            setKeyword(e.target.value.trim().toLowerCase())
          }
        }}
      />
      {roles
        .filter(role => (keyword ? role.name.toLowerCase().includes(keyword) : true))
        .map(role => (
          <Checkbox
            label={role.name}
            id={role.name.replaceAll(' ', '-')}
            key={role.id}
            name="role"
            checked={selectedRoles.map(role => role.name).includes(role.name)}
            className={styles.checkbox}
            onChange={() => {
              let newRoles = [...selectedRoles]
              if (!newRoles.map(role => role.name).includes(role.name)) {
                newRoles.push(role)
              } else {
                newRoles = newRoles.filter(roleItem => roleItem.name !== role.name)
              }
              setSelectedRoles(newRoles)
              onApply(
                newRoles.map(role => ({
                  name: role.name,
                  value: role.name,
                })),
              )
            }}
          />
        ))}
      <div className={styles.buttonWrapper}>
        <div className={styles.action}>
          <Button label="Apply" size="medium" theme="primary" className={styles.button} onClick={closeFilter} />
        </div>
      </div>
    </section>
  )
}

RolesFilter.propTypes = {
  roles: PropTypes.array,
  onApply: PropTypes.func,
  filterValues: PropTypes.array,
  closeFilter: PropTypes.func,
}

export default RolesFilter
